<template>
  <CModal :show.sync="show" centered size="lg">
    <template #header>
      <h5 class="modal-title">
        <translate translate-context="photo_search.tag_manager">Tag Manager</translate>
      </h5>
      <CButtonClose @click="show = false"/>
    </template>

    <PComponentLoader :loading="loading">
      <template v-if="show && !loading">
        <div class="alert alert-info mb-3">
          <CIcon name="cil-info" class="mr-2"/>
          <translate
            translate-context="photo_search.tag_manager"
            :translate-params="{ count: numSelected }"
          >
            Actions will be applied to %{count} selected photos.
          </translate>
        </div>

        <div v-if="mediaTagDefinitions.length === 0" class="alert alert-warning">
          <translate translate-context="photo_search.tag_manager">
            No media tag definitions available.
          </translate>
        </div>

        <template v-else>
          <!-- Tag semplici e checkbox in righe compatte -->
          <div v-if="simpleDefinitions.length > 0" class="tags-table">
            <TagOperationItem
              v-for="definition in simpleDefinitions"
              :key="definition.code"
              ref="tagItems"
              :definition="definition"
              @apply="handleApply"
            />
          </div>

          <!-- Tag free-form in blocchi separati -->
          <TagOperationBlock
            v-for="definition in tagsDefinitions"
            :key="definition.code"
            ref="tagBlocks"
            :definition="definition"
            @apply="handleApply"
          />
        </template>
      </template>
    </PComponentLoader>

    <template #footer>
      <CButton @click="show = false" color="secondary" v-translate translate-context="common">Close</CButton>
    </template>
  </CModal>
</template>

<script>
import {mapGetters} from "vuex";
import PComponentLoader from "@/domain/core/components/PComponentLoader.vue";
import TagOperationItem from "./TagOperationItem.vue";
import TagOperationBlock from "./TagOperationBlock.vue";
import {TAG_SCOPE_VALUE} from "@/domain/core/constant/tagScope";

export default {
  name: "TagManagerModal",
  components: {
    PComponentLoader,
    TagOperationItem,
    TagOperationBlock
  },
  data() {
    return {
      loading: false,
      show: false
    }
  },
  computed: {
    ...mapGetters('photoSearch', [
      'tagDefinitions',
      'numSelected'
    ]),
    mediaTagDefinitions() {
      if (!this.tagDefinitions) return []
      return this.tagDefinitions.filter(def => def.scopes && def.scopes.includes(TAG_SCOPE_VALUE.MEDIA))
    },
    sortedDefinitions() {
      return [...this.mediaTagDefinitions].sort((a, b) => (a.order || 0) - (b.order || 0))
    },
    // Tag semplici e checkbox (non "tags")
    simpleDefinitions() {
      return this.sortedDefinitions.filter(def => def.input_type !== 'tags')
    },
    // Tag free-form
    tagsDefinitions() {
      return this.sortedDefinitions.filter(def => def.input_type === 'tags')
    }
  },
  emits: ['apply'],
  methods: {
    async open() {
      this.show = true
      // Reset all items when modal opens
      this.$nextTick(() => {
        if (this.$refs.tagItems) {
          const items = Array.isArray(this.$refs.tagItems) ? this.$refs.tagItems : [this.$refs.tagItems]
          items.forEach(item => item.reset())
        }
        if (this.$refs.tagBlocks) {
          const blocks = Array.isArray(this.$refs.tagBlocks) ? this.$refs.tagBlocks : [this.$refs.tagBlocks]
          blocks.forEach(block => block.reset())
        }
      })
    },

    async handleApply({code, operation}) {
      // Build single operation payload and emit immediately
      const operations = [{
        code,
        ...operation
      }]

      try {
        await this.emitPromised('apply', {operations})
        this.notifySuccess(this.$pgettext('photo_search.tag_manager', 'Tag aggiornato'))
      } catch (error) {
        this.notifyError(this.$pgettext('photo_search.tag_manager', 'Errore durante l\'aggiornamento'))
      }
    }
  }
}
</script>

<style scoped>
.tags-table {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fff;
  max-height: 350px;
  overflow-y: auto;
}
</style>
